export default {
  dash_activity: 'Recent activity',
  dash_wallet: 'Your wallet',
  total_wallet: 'Total',
  gray_wallet: 'Gray',
  white_wallet: 'White',
  dash_verification: 'Please, follow the KYC requirements to access all the features of the platform',
  dash_verification_wait: 'Your documents are still under review'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/dashboard_view.js